// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"loadingscreen_backdrop__2S65y","localBackrop":"loadingscreen_localBackrop__TgG8_"};